<template>
 <Tables ref="tableGridComission"
              :columns="['Corretor', 'Empreendimento', 'Dt. da Venda', 'Valor Total', 'Comissão', 'Status', 'N° de Parcelas', 'Parcelas Quitadas', 'Cliente', 'Unidade', '']"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad"
            >
              <tr v-for="comissao in consultacomissao" v-bind:key="comissao.id">
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.conta.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.empreendimento.nome" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.dataVendaFormatada" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.proposta.valorTotalFormatado" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.valorTotalComissaoFormatado" />
                  <TableColumn :newState="true" :newStatusNumber="comissao.status" :descriptionNewStatus="['Quitado','Atrasado', 'Em Andamento'][comissao.status]" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.reComissaoParcela == 0 ? '0' : comissao.reComissaoParcela" />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.reComissaoParcelaQuitada == 0 ? '0' : comissao.reComissaoParcelaQuitada"  />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="comissao.proposta.cliente.nome"  />
                  <TableColumn :IsText="true"   v-on:Edit="$emit('edit', comissao)" :status="1" :value="`${comissao.proposta.empreendimentoUnidade.unidade} - ${comissao.proposta.empreendimentoUnidade.grupo}`"/>
                  <TableColumn :IsActionsButtons="true" v-on:Delete ="$emit('deleteCommission', comissao.id)" :status="1" :HasChange = "false"/>
              </tr>
</Tables>
</template>

<script>
import TableComission from './TableComission'
export default TableComission
</script>

<style scoped>
.tabledata{
font: normal normal normal 15px/20px Segoe UI;
letter-spacing: 0px;
color: #656565;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/TableComission/TableComission.vue